<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/IoJbdu/tc-custom/9781250111609.jpg?1724850662402" alt="This image is the cover for the book Boy Made of Blocks"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Boy Made of Blocks
      </h1>
      <p class="bookDescription body article font2">
        <p><b><i>A Boy Made of Blocks</i> is a funny, heartwarming story of family and love inspired by the author's own experiences with his son, the perfect latest obsession for fans of The Rosie Project, David Nicholls and Jojo Moyes. </b><br/><br/><b>A father who rediscovers love</b><br/><br/>Alex loves his wife Jody, but has forgotten how to show it. He loves his son Sam, but doesn't understand him. He needs a reason to grab his future with both hands.<br/><br/><b>A son who shows him how to live</b><br/><br/>Meet eight-year-old Sam: beautiful, surprising - and different. To him the world is a frightening mystery. But as his imagination comes to life, his family will be changed . . . for good.<br/><br/>"One of those wonderful books that makes you laugh and cry at the same time."<br/><i>Good Housekeeping</i><br/><br/>"Funny, expertly plotted and written with enormous heart. Readers who enjoyed <i>The Rosie Project</i> will love<i> A Boy Made of Blocks</i> - I did."<br/>Graeme Simsion<br/><br/>"Very funny, incredibly poignant and full of insight. Awesome."<br/>Jenny Colgan<br/><br/>"'A wonderful, warm, insightful novel about family, friendship and love."<br/><i>Daily Mail</i><br/><br/>“A charming and timely tale of learning to connect in the digital age.” <br/><i>Kirkus</i><br/><br/>"This is an author who understands fatherhood and boyhood and everything in between. A truly beautiful book." <br/>Matthew Dicks, author of <i>Memoirs of An Imaginary Friend<br/></i><br/><i>"A Boy Made of Blocks </i>will make you laugh and cry in equal measure; a book you won’t soon forget." <br/>Brenda Janowitz, author of<i> The Dinner Party</i></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Keith Stuart
      </h2>
      
      <p class="authorDescription body article">KEITH STUART is the games editor of the<I> Guardian </I>and a veteran video game journalist who has spent 20 years playing, investigating, and writing about video games and their possibilities.  He lives with his family in Somerset, England. <I>A Boy Made of Blocks </I>is his first book.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?24c7ef3d